import { CSSProperties, SVGProps } from 'react';

import { COLORS } from '../../../lib';

interface IShareIconProps extends SVGProps<SVGSVGElement> {
  color?: CSSProperties['color'];
}

export const ShareIcon = ({ color, ...props }: IShareIconProps) => {
  const fill = color ?? COLORS['base-100'];

  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.93082 17.8094C3.93082 17.0467 3.76738 14.0367 6.14179 11.6487C7.73986 10.0415 10.1315 9.76277 12.9917 9.63565V5.75C12.9917 5.09926 13.7637 4.75728 14.2457 5.19453L20.7538 11.0989C21.0796 11.3945 21.0822 11.9057 20.7595 12.2046L14.2513 18.2319C13.7712 18.6765 12.9917 18.336 12.9917 17.6816V13.8197C11.1757 13.8696 9.88216 13.9852 8.70688 14.359C6.43532 15.0817 5.0874 18.1806 4.7239 19.1245C4.66122 19.2873 4.50596 19.3984 4.33153 19.3984C4.10772 19.3984 3.92635 19.2171 3.92705 18.9933C3.92835 18.5812 3.93082 18.1076 3.93082 17.8094Z"
        fill={fill}
      />
    </svg>
  );
};
